import { z } from 'zod';

export const backfillR2UploadsRequestSchema = z.object({
  cursor: z.string().optional(),
  limit: z.number().int().positive().optional(),
});

export type IBackfillR2UploadsRequest = z.infer<typeof backfillR2UploadsRequestSchema>;
